import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";
import { authReducer } from "./reducers/authReducer";
import usersReducer from "./reducers/usersReducer";
import productsReducer from "./reducers/productsReducer";
import associationReducer from "./reducers/associationReducer";

export const store = configureStore(
  {
    middleware: [thunk],
    reducer: {
      auth: authReducer,
      users: usersReducer,
      products: productsReducer,
      association: associationReducer,
    },
  },

  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
